import ConfirmCorrect from "@/components/ViewProfile/UserDetails/confirmCorrect.component";
import MarketingOptIn from "@/components/ViewProfile/UserDetails/marketingOptIn.component";
import PasswordReset from "@/components/ViewProfile/UserDetails/passwordReset.component";
import PreferComm from "@/components/ViewProfile/UserDetails/preferComm.component";
import PreferLang from "@/components/ViewProfile/UserDetails/preferLang.component";
import { Card, CardContent } from "@/shadcn/components/ui/card";
import { UserProfileDetails } from "@/types";
import React from "react";

type UserDetailsFormProps = {
  initialDetails: UserProfileDetails;
};

const UserDetailsForm: React.FC<UserDetailsFormProps> = ({
  initialDetails,
}) => {
  return (
    <>
      <Card className="mx-auto h-fit w-full max-w-4xl p-6 shadow-lg">
        <CardContent className="space-y-4">
          <h2 className="text-xl font-semibold">Profile Details</h2>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div className="flex flex-wrap gap-2">
              <strong>Full Name:</strong>
              <div>{initialDetails.fullName || "N/A"}</div>
            </div>
            <div className="flex flex-wrap gap-2">
              <strong>Email:</strong>
              <div>{initialDetails.email || "N/A"}</div>
            </div>
            <div className="flex flex-wrap gap-2">
              <strong>Title:</strong>
              <div>{initialDetails.title || "N/A"}</div>
            </div>
            <div className="flex flex-wrap gap-2">
              <strong>Designation:</strong>
              <div>{initialDetails.designation || "N/A"}</div>
            </div>
            <div className="flex flex-wrap gap-2">
              <strong>Phone Number:</strong>
              <div>{initialDetails.phoneNumber || "N/A"}</div>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card className="mx-auto h-fit w-full max-w-4xl p-6 shadow-lg">
        <CardContent className="flex flex-col gap-4">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold">Update Profile</h2>
            <ConfirmCorrect />
          </div>
          <PreferLang initialValue={initialDetails.preferredLanguage} />
          <PreferComm
            initialValue={initialDetails.preferredCommunicationMethods}
          />
          <MarketingOptIn initialValue={initialDetails.marketingOptIn} />
          <PasswordReset />
        </CardContent>
      </Card>
    </>
  );
};

export default UserDetailsForm;
